/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { profileVideos } from "../../../../utils/profileVideo";
import ShowVideo from "./show-video";
import UploadVideo from "./upload-video";
import { useDispatch, useSelector } from "react-redux";
import { getProfileVideosAction } from "../../../../store/ProfileVideoActions";
import useAuthUser from "react-auth-kit/hooks/useAuthUser";
import { useAxiosInstance } from "../../../../services/Interceptor";
import LoadingSpinner from "../../../../components/LoadingSpinner";
import { ToastContainer } from "react-toastify";

export default function ProfileVideo() {
  const dispatch = useDispatch();
  const r_profileVideo = useSelector((state) => state.profileVideo);
  const auth = useAuthUser();
  const apiInstance = useAxiosInstance();

  useEffect(() => {
    dispatch(getProfileVideosAction(apiInstance, auth.user.id));
  }, [dispatch]);

  return (
    <div className="relative">
      <ToastContainer position="top-right" autoClose={3000} />
      {r_profileVideo.loading && (
        <div className="absolute top-0 left-0 bg-white/75 w-full h-full pt-24">
          <LoadingSpinner />
        </div>
      )}
      <div className="w-full mx-auto border border-blue-700 rounded items-center p-5">
        <div className="w-full mx-auto">
          {profileVideos.map(
            (item, key) =>
              item.id !== 6 && (
                <div
                  key={key}
                  className="odd:bg-[#E6E3E3] flex justify-between items-center py-4  px-3"
                >
                  <span>{item.name}</span>
                  <>
                    <ShowVideo
                      profileVideo={item}
                      savedVideos={r_profileVideo.profileVideos}
                    />
                    <UploadVideo
                      profileVideo={item}
                      savedVideos={r_profileVideo.profileVideos}
                    />
                  </>
                </div>
              ),
          )}
        </div>
      </div>
    </div>
  );
}
